import { createFileRoute } from "@tanstack/react-router";
import { DownloadPage } from "@/features/offboarding";

/** Public: the emailed token is the permission. No sign-in required. */
export const Route = createFileRoute("/download/$token")({
  component: Download,
});

function Download() {
  const { token } = Route.useParams();
  return <DownloadPage token={token} />;
}
